import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminVipGroupService } from '@/modules/vip-group/services/admin-vip-group.service'
import { VipGroupRequestModel } from '@/modules/vip-group/models/vip-group-request.model'
import { VipGroupResourceModel } from '@/modules/vip-group/models/vip-group-resource.model'

@vservice()
export class VipGroupCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminVipGroupService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(data: VipGroupResourceModel) {
    return this.service.store(this.requestData(data))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  requestData(data): VipGroupRequestModel {
    return {
      active: data.active,
      description: data.description,
      percent: data.percent,
      title: data.title,
      users: data.users
    }
  }

}
